export const colors = {
     blue:     '#66C',
     darkblue: '#55B'
}